var map = {
	"./default.png": 227,
	"./doc.png": 454,
	"./docx.png": 455,
	"./jpg.png": 456,
	"./pdf.png": 457,
	"./png.png": 458,
	"./txt.png": 459,
	"./xls.png": 460,
	"./xlsx.png": 461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;